import styled from "@emotion/styled"
import { PCheckbox } from "@porsche-design-system/components-react"
import type { CheckboxChangeEventDetail } from "@porsche-design-system/components-react"
import { spacingStaticSm } from "@porsche-design-system/components-react/emotion"
import type { PropsWithChildren } from "react"
import { useCallback } from "react"
import { NewBadge } from "src/components/badge/NewBadge"
import { Tooltip } from "../../tooltip/Tooltip"

export interface CheckboxProps extends PropsWithChildren {
	checked?: boolean
	className?: string
	compact?: boolean
	disabledHint?: string
	indeterminate?: boolean
	isNew?: boolean
	name?: string
	onChange?: (value: boolean) => void
	state?: "error" | "success"
}

export const Checkbox = (props: CheckboxProps) => {
	const { checked, children, className, compact, disabledHint, indeterminate, isNew, name, onChange, state } = props

	const handleChange = useCallback(
		(e: CustomEvent<CheckboxChangeEventDetail>) => {
			onChange?.((e.target as HTMLInputElement).checked)
		},
		[onChange],
	)

	return (
		<Wrapper>
			<Tooltip content={disabledHint} appendToBody>
				<PCheckbox
					className={className}
					data-testid={`checkbox_${name}`}
					state={state}
					compact={compact}
					name={name}
					disabled={!!disabledHint || disabledHint === ""}
					checked={checked}
					indeterminate={indeterminate}
					onChange={handleChange}
				>
					{children && (
						<span slot="label">
							{children}
							{isNew && <StyledNewBadge compact />}
						</span>
					)}
				</PCheckbox>
			</Tooltip>
		</Wrapper>
	)
}

const Wrapper = styled.div`
	display: inline-flex;
	vertical-align: top;
`

const StyledNewBadge = styled(NewBadge)`
	margin-inline-start: ${spacingStaticSm};
`
